<template>
  <section class="home-bed">
    <div class="img-bed">
      <black-bar title="开卡激活">
      </black-bar>
    </div>
    <div class="title">
      <span class="key">机型最佳刷卡位置</span>
      <span class="val">
        <p @click="ifSelect()">{{selectList[selectIndex]}}</p>
        <img src="../assets/img/noAccess/btn_back@3x.png" />
      </span>
      <ul class="select"
          v-if="selectType">
        <li v-for="(item,index) in selectList"
            :key="index"
            @click="selectItem(index)">
          <span v-if="index!=selectIndex">{{item}}</span>
        </li>
        <!-- <li>oppo系列</li>
        <li>华为系列</li> -->
      </ul>

    </div>
    <img src="../assets/img/noAccess/xiaomi.png"
         alt=""
         class="banner"
         v-if="selectIndex==0">
    <img src="../assets/img/noAccess/oppo.png"
         alt=""
         class="banner"
         v-if="selectIndex==1">
    <img src="../assets/img/noAccess/huawei.png"
         alt=""
         class="banner"
         v-if="selectIndex==2">
    <div class="btn"
         @click="goRouter('payIndex')">完成</div>

  </section>
</template>

<script>
import blackBar from '@/components/blackBar'
export default {
  name: 'usePhone',
  data () {
    return {
      loading: true,
      num: 20,
      selectType: false,
      selectList: ['红米系列', 'oppo系列', '华为系列'],
      selectIndex: 0
    }
  },
  components: {
    blackBar
  },
  created () {
    // if (window.sessionStorage.getItem('token')) {
    //   this.loading = true
    // }
  },
  methods: {
    ifSelect () {
      this.selectType = true
    },
    selectItem (index) {
      this.selectIndex = index
      this.selectType = false
    },
    goRouter (router) {
      if (this.loading) {
        this.$router.push({
          name: router
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home-bed {
  // background: #eee;
  min-height: 100%;
  overflow: scroll;
  position: relative;
  text-align: center;
}
.img-bed {
  font-size: 0;
  margin-bottom: 12px;
  background: #fff;
  position: relative;
  width: 100%;
  // height: 320px;
  > div {
    position: absolute;
    margin: 0 auto;
    width: 100%;
    padding: 20px 0;
    text-align: center;
    background-color: #666;
  }
  img {
    width: 100%;
  }
}
.title {
  width: 92%;
  margin-left: 4%;
  display: flex;
  font-size: 28px;
  font-weight: 400;
  color: #333333;
  margin-top: 32px;
  height: 40px;
  line-height: 40px;
  position: relative;
  .select {
    position: absolute;
    top: 56px;
    right: -5px;
    width: 180px;
    // height: 140px;
    background: #ffffff;
    box-shadow: 0px 0px 8px 1px rgba(0, 0, 0, 0.14901960784313725);
    border-radius: 8px 8px 8px 8px;
    li {
      line-height: 70px;
    }
    // li {
    //   border-bottom: 1px solid #aaaaaa;
    // }
    li:nth-child(1) {
      border-bottom: 1px solid #dcdcdc;
    }
  }
  span {
    width: 50%;
  }
  .key {
    text-align: left;
  }
  .val {
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    p {
    }
    img {
      width: 24px;
      height: 24px;
    }
  }
}

.banner {
  width: 60%;
  margin-top: 124px;
}

.btn {
  position: absolute;
  left: 0;
  bottom: 80px;
  width: 92%;
  margin-left: 4%;
  height: 98px;
  line-height: 98px;
  background: #4a8ef7;
  box-shadow: 0px 6px 20px 1px rgba(63, 138, 247, 0.2);
  border-radius: 49px 49px 49px 49px;
  font-size: 32px;
  font-weight: 400;
  color: #ffffff;
}
</style>
